// Shared types for MatchingResultsModal feature (dashboard)
// Keep metric/sort unions single-source-of-truth here; used by DTO, modal, column config.

export const MATCHING_RESULTS_METRICS = ["proposing", "interview", "offer", "accept"] as const;
export type TMatchingResultsMetric = (typeof MATCHING_RESULTS_METRICS)[number];

export const MATCHING_RESULTS_SORT_FIELDS = [
  "status",
  "talentName",
  "caseName",
  "jobName",
  "companyName",
  "metricDate",
  "caseOwner",
  "companySpecificIndustry",
  "jobRecruiter",
  "talentPersonInCharge",
] as const;
export type TMatchingResultsSortBy = (typeof MATCHING_RESULTS_SORT_FIELDS)[number];

export type TMatchingResultsSortDir = "asc" | "desc";

// Row item - mirrors BE CaseMatchListItem shape
export type TMatchingResultsItem = {
  id: number;
  status: number;
  talent: { id: number; fullName: string | null; companySpecificIndustry: string | null; personInChargeName: string | null } | null;
  case: { id: number; name: string | null } | null;
  job: { id: number; jobName: string | null; recruiterName: string | null } | null;
  company: { id: number; companyName: string | null } | null;
  caseOwner: { id: number; fullName: string | null } | null;
  // All four date fields returned; FE picks the active metric's date for display
  proposalDate: string | null;
  interviewDate: string | null;
  companyOfferDate: string | null;
  offerAcceptDate: string | null;
};
